import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import IndexCarousel from '../main/IndexCarousel';
import '../main/submenulist.scss';
import ApiSurvey from '../../api/survey';
import Swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';
import { useHistory } from 'react-router-dom';
import { StaticImage } from '../../utils/image';
// import YoutuberPlayer from "./react-player/YoutuberPlayer";
import { fade, makeStyles } from '@material-ui/core';
// import SurveyCard from './newLayout/index';
import SurveyCardMobile from '../listening/newLayoutMobile';
import { checkUser } from '../../utils/checkUser';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import ApiMaster from '../../api/master';
import ApiLaw from '../../api/law';
import { useWindowSize } from '../../utils/WindowSize';
import SurveyCardV2 from './desktop/survey';
import ProjectCardV2 from './desktop/project';
import SurveyCardV2Mobile from './mobile/survey';
import ProjectCardV2Mobile from './mobile/project';
import EvaluationDeadlineView from './EvaluationDeadlineView';
import './index.scss';
import AlertInfo from '../../utils/AlertInfo';
import { Input, Card } from 'antd';
import { SearchOutlined } from '@material-ui/icons';
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPollH,
  faTimesCircle,
  faArrowCircleDown,
  faSync,
  faSlidersH,
  faBalanceScale,
} from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
const { Search } = Input;


const useStylesAvatar = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
}));

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    borderRadius: '100px',
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
    backgroundColor: '#e5e6ee',
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),

    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',

    [theme.breakpoints.up('md')]: {
      width: '40ch',
    },
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));

const scoreText = [
  { value: "last", label: "#ล่าสุด", color: "#0c4da2" },
  { value: 'evaluate', label: '#ประเมินผลสัมฤทธิ์', color: '#756039' },
  { value: "answer", label: "#ตอบมากที่สุด", color: "#a51830" },
  // { value: 'read', label: '#ความนิยม', color: '#387436' },
  { value: "progress", label: "#ความคืบหน้า", color: "#387436" },
];

const conditionText = [
  { value: "and", label: "และ" },
  { value: 'or', label: 'หรือ' },
  { value: "except", label: "ยกเว้น" },
];

const ListeningPageindex = () => {
  const [width, height] = useWindowSize();
  const [isMore, setisMore] = useState(true);
  const [surveys, setsurveys] = useState([]);
  const [surveyFilter, setSurveyFilter] = useState([]);
  const [card_type, setcard_type] = useState('last');
  const [condition_type, setcondition_type] = useState('');
  const history = useHistory();
  const classes = useStyles();
  const classAvatar = useStylesAvatar();
  const userState = useSelector((state) => state.user);
  const [projects, setprojects] = useState([]);
  const [entitys, setEntitys] = useState([]);
  const [process, setprocess] = useState([]);
  const [law_group, setlawgroup] = useState([]);
  const [agencyOption, setAgencyOption] = useState([
    { value: 0, label: "ทั้งหมด" },
  ]);
  const [ministryOption, setMinistryOption] = useState([
    { value: 0, label: "ทั้งหมด" },
  ]);
  const [surveyTypeOption, setSurveyTypeOption] = useState([
    { value: 0, label: "ทั้งหมด" },
  ]);
  const [lawHierarchyOption, setLawHierarchyOption] = useState([
    { value: null, label: "เลือกตามศักดิ์กฎหมาย" },
  ]);

  const [totalPage, setTotalPage] = useState(1);
  const [totalItem, setTotalItem] = useState(9999);
  const [pageSize, setPageSize] = useState(10);
  const [pageNo, setPageNo] = useState(1);
  const [search, setsearch] = useState({
    searchText: "",
    ministry_id: 0,
    agency_id: 0,
    statusSurvey: "",
    surveyType: "",
    inSystemSelected: "",
    yearSelected: moment().year(),
    yearEvaluateSelected: '',
    monthEvaluateSelected: ''
  });
  const searchInputRef = useRef(null);
  const [nonEvaluateSearchDraft, setNonEvaluateSearchDraft] = useState("");
  const conditionTokenMap = {
    and: ".และ.",
    or: ".หรือ.",
    except: ".ยกเว้น.",
  };
  const conditionValueMap = {
    ".และ.": "and",
    ".หรือ.": "or",
    ".ยกเว้น.": "except",
  };
  const conditionLabelMap = {
    ".และ.": "และ",
    ".หรือ.": "หรือ",
    ".ยกเว้น.": "ยกเว้น",
  };



  useEffect(() => {
    Swal.showLoading();
    // const getSurveyResult = getSurvey();
    // const getProjectSurveyResult = getProjectSurvey();
    const getHomeFilter = getFilterOption();
    const getLawHierarchy = getLawHierarchyOption();
    try {
      Promise.all([getHomeFilter, getLawHierarchy])
        .then(data => {
          Swal.close();
          //AlertInfo(``, `เพื่อเพิ่มประสิทธิภาพในการใช้งาน ระบบกลางทางกฎหมาย ขอแจ้งปิดปรับปรุง ในวันที่ 24 ก.พ. เวลา 18.00 น. ถึงวันที่ 25 ก.พ. เวลา 04.00 น. โดยจะไม่สามารถเข้าใช้งานได้ในช่วงเวลาดังกล่าวขออภัยในความไม่สะดวกมา ณ โอกาสนี้`)
        })
    } catch (error) {
      Swal.close();
    }
    return () => { };
  }, []);

  useEffect(() => {
    if (!(entitys.length == 0)) {
      getOrderSurvey({ orderFilter: card_type })
    }
    return () => {
    }
  }, [card_type])

  const parseSearchChunks = (value = "") => {
    return value
      .split(/(\.และ\.|\.หรือ\.|\.ยกเว้น\.)/g)
      .filter((chunk) => chunk !== "");
  };

  const countConditionTokens = (value = "") => {
    return parseSearchChunks(value).filter((chunk) => Boolean(conditionLabelMap[chunk])).length;
  };

  const normalizeSearchChunks = (chunks = []) => {
    const isCondition = (chunk) => Boolean(conditionLabelMap[chunk]);
    const cleaned = chunks.filter((chunk) => chunk && chunk.trim() !== "");
    while (cleaned.length > 0 && isCondition(cleaned[0])) {
      cleaned.shift();
    }
    while (cleaned.length > 0 && isCondition(cleaned[cleaned.length - 1])) {
      cleaned.pop();
    }
    const normalized = [];
    cleaned.forEach((chunk) => {
      if (!isCondition(chunk)) {
        normalized.push(chunk);
        return;
      }
      if (normalized.length === 0) {
        return;
      }
      if (isCondition(normalized[normalized.length - 1])) {
        normalized[normalized.length - 1] = chunk;
      } else {
        normalized.push(chunk);
      }
    });
    while (normalized.length > 0 && isCondition(normalized[normalized.length - 1])) {
      normalized.pop();
    }
    return normalized;
  };

  const removeSearchChunk = (index) => {
    setsearch((prev) => {
      const currentChunks = parseSearchChunks(prev.searchText || "");
      if (index < 0 || index >= currentChunks.length) {
        return prev;
      }
      currentChunks.splice(index, 1);
      return {
        ...prev,
        searchText: normalizeSearchChunks(currentChunks).join(""),
      };
    });
  };

  const appendSearchTerm = (value = "") => {
    const nextTerm = value.trim();
    if (!nextTerm) {
      return;
    }
    const tokenRegex = /(\.และ\.|\.หรือ\.|\.ยกเว้น\.)$/;
    const activeToken = condition_type ? conditionTokenMap[condition_type] : conditionTokenMap.and;
    const composeSearchText = (currentText = "", term = "") => {
      if (!currentText) {
        return term;
      }
      if (tokenRegex.test(currentText)) {
        return `${currentText}${term}`;
      }
      if (activeToken) {
        if (countConditionTokens(currentText) >= 2) {
          return currentText;
        }
        return `${currentText}${activeToken}${term}`;
      }
      return `${currentText}${term}`;
    };
    setsearch((prev) => ({ ...prev, searchText: composeSearchText(prev.searchText || "", nextTerm) }));
  };

  const composeSearchTextWithPending = (pendingValue = "") => {
    const nextTerm = pendingValue.trim();
    if (!nextTerm) {
      return search.searchText || "";
    }
    const tokenRegex = /(\.และ\.|\.หรือ\.|\.ยกเว้น\.)$/;
    const activeToken = condition_type ? conditionTokenMap[condition_type] : conditionTokenMap.and;
    const currentText = search.searchText || "";
    if (!currentText) {
      return nextTerm;
    }
    if (tokenRegex.test(currentText)) {
      return `${currentText}${nextTerm}`;
    }
    if (activeToken) {
      if (countConditionTokens(currentText) >= 2) {
        return currentText;
      }
      return `${currentText}${activeToken}${nextTerm}`;
    }
    return `${currentText}${nextTerm}`;
  };

  const applyConditionType = (nextType) => {
    const token = conditionTokenMap[nextType];
    const currentText = search.searchText || "";
    const tokenAtTailRegex = /(\.และ\.|\.หรือ\.|\.ยกเว้น\.)$/;
    if (!currentText) {
      const pendingTerm = nonEvaluateSearchDraft.trim();
      if (pendingTerm) {
        setsearch({ ...search, searchText: `${pendingTerm}${token}` });
        setNonEvaluateSearchDraft("");
        setcondition_type(nextType);
      }
      return;
    }
    const conditionCount = countConditionTokens(currentText);
    if (conditionCount >= 2 && !tokenAtTailRegex.test(currentText)) {
      setcondition_type(nextType);
      return;
    }
    // Allow multiple condition tokens in one query; only normalize the last token if user re-clicks condition.
    const nextText = tokenAtTailRegex.test(currentText)
      ? currentText.replace(tokenAtTailRegex, token)
      : `${currentText}${token}`;
    setcondition_type(nextType);
    setsearch({ ...search, searchText: nextText });
  };

  useEffect(() => {
    const chunks = parseSearchChunks(search.searchText || "");
    const lastCondition = [...chunks].reverse().find((chunk) => conditionValueMap[chunk]);
    const nextCondition = lastCondition ? conditionValueMap[lastCondition] : "";
    if (nextCondition !== condition_type) {
      setcondition_type(nextCondition);
    }
  }, [search.searchText, condition_type]);



  const getSurvey = async () => {
    // Swal.showLoading();
    try {
      const survey = await ApiSurvey.get({
        size: pageSize > totalItem ? totalItem : pageSize,
        page: pageNo,
        sort: card_type,
        ...search
      });
      if (survey.status == 200) {
        // Swal.close();
        const { data, law_group, entitys, lastPage, count } = survey.data;
        setsurveys(pageNo == 1 ? data : [...surveys, ...data]);
        setSurveyFilter(pageNo == 1 ? data : [...surveyFilter, ...data]);
        setlawgroup(law_group);
        setEntitys(entitys);
        setTotalPage(lastPage);
        setTotalItem(count);
      }
    } catch (error) {
      console.log(error);
    }

  };

  const getSurveyRefresh = async (pageNoParams = 1, searchParams = {}) => {
    console.log('getSurveyRefresh::')
    Swal.showLoading();
    try {
      const survey = await ApiSurvey.get({
        size: pageNoParams == 1 ? 10 : pageSize > totalItem ? totalItem : pageSize,
        page: pageNoParams == 1 ? 1 : pageNo,
        sort: card_type,
        ...searchParams
      });
      if (survey.status == 200) {
        Swal.close();
        const { data, law_group, entitys, lastPage, count } = survey.data;
        if (pageNoParams == 1) {
          setsurveys(data);
          setSurveyFilter(data);
        }
        else {
          setsurveys(pageNo == 1 ? data : [...surveys, ...data]);
          setSurveyFilter(pageNo == 1 ? data : [...surveyFilter, ...data]);
        }
        setlawgroup(law_group);
        setEntitys(entitys);
        setTotalPage(lastPage);
        setTotalItem(count);
      }
    } catch (error) {
      console.log(error);
    }

  };


  const getSurveySearch = async (searchParams = "") => {
    Swal.showLoading();
    try {
      const survey = await ApiSurvey.getSearch(searchParams == "" ? search : searchParams);
      Swal.close();
      if (survey.status == 200) {
        // Swal.close();
        const { data, law_group, entitys, lastPage, count } = survey.data;
        setsurveys(data);
        setSurveyFilter(data);

        // setlawgroup(law_group);
        // setEntitys(entitys);
        // setTotalPage(lastPage);
        // setTotalItem(count);
      }
    } catch (error) {
      console.log(error);
    }

  };

  const getProjectSurvey = async () => {
    // Swal.showLoading();
    const survey = await ApiSurvey.surveyGroupByProject();
    if (survey.status == 200) {
      // Swal.close();
      const { data, entitys } = survey.data;
      console.log("entitys::", entitys);
      setprojects(data);
      setEntitys(entitys);
      // setsurveys(data);
      // setSurveyFilter(data);
    }
  };

  const getFilterSurvey = async ({
    ministry,
    agency,
    surveyType,
    statusSurvey,
    searchFilter,
  }) => {
    const normalizedMinistry = ministry ?? 0;
    const normalizedAgency = agency ?? 0;
    setsearch((prev) => ({
      ...prev,
      ministry_id: normalizedMinistry,
      agency_id: normalizedAgency,
      statusSurvey: statusSurvey,
      surveyType: surveyType,
      lawHierarchy: lawHierarchy,
    }));
    getSurveyRefresh(1, {
      searchText: search.searchText,
      ministry_id: normalizedMinistry,
      agency_id: normalizedAgency,
      statusSurvey: statusSurvey,
      surveyType: surveyType,
      lawHierarchy: lawHierarchy,
    });
  };

  const getOrderSurvey = async ({ orderFilter }) => {
    let survey = [...surveys];
    if (orderFilter == 'last') {
      setPageNo(1);
      setPageSize(10);
      getSurveyRefresh(1);
      setsearch({
        searchText: ""
      })
      setisMore(true)
      //survey = _.orderBy(surveyFilter, 'created_date', 'desc');
    } else if (orderFilter == 'answer') {
      setPageNo(1);
      setPageSize(10);
      getSurveyRefresh(1);
      setsearch({
        searchText: ""
      })
      setisMore(true)
      // survey = _.orderBy(
      //   surveyFilter,
      //   [
      //     (o) => {
      //       return o.answer_count || '';
      //     },
      //   ],
      //   ['desc']
      // );
    } else if (orderFilter == 'read') {
      setPageNo(1);
      setPageSize(10);
      getSurveyRefresh(1);
      setsearch({
        searchText: ""
      })
      setisMore(true)
      // survey = _.orderBy(
      //   surveyFilter,
      //   [
      //     (o) => {
      //       return o.view_count || '';
      //     },
      //   ],
      //   ['desc']
      // );
    } else if (orderFilter == 'popular') {
      // survey = _.orderBy(
      //   surveyFilter,
      //   [
      //     (o) => {
      //       return o.view_count || '';
      //     },
      //   ],
      //   ['desc']
      // );
    }
    else if (orderFilter == 'progress') {
      setPageNo(1);
      setPageSize(10);
      getSurveyRefresh(1);
      setsearch({
        searchText: ""
      })
      setisMore(true)
    }

    //setSurveyFilter(survey);
  };

  const handleFavorite = async (e, item) => {
    e.stopPropagation();
    if (checkUser(userState)) {
      const model = {
        project_id: item.project_id,
      };
      try {
        const result = await ApiSurvey.favoriteProject(model);
        if (result.status == 200) {
          //filter
          const likesFilter = [...surveyFilter];
          const indexFilter = likesFilter.findIndex(
            (x) => parseInt(x.project_id) == item.project_id
          );
          likesFilter[indexFilter].is_like = !likesFilter[indexFilter].is_like;

          setSurveyFilter(likesFilter);
        }
      } catch (error) {
        console.log(error);
        Swal.close();
      }
    }
  };

  const getFilterOption = async () => {
    const filter = await ApiMaster.homeFilter();
    if (filter.status == 200) {
      const { data } = filter.data;

      setAgencyOption([...agencyOption, ...data.agency]);
      setMinistryOption([...ministryOption, ...data.ministry]);
      setSurveyTypeOption([
        ...surveyTypeOption,
        // ...data.survey_type
        ...data.survey_type.filter((x) => x.label == "ร่างกฎหมาย" || x.label == "ประเมินผลสัมฤทธิ์"),
      ]);
    }
  };

  const getLawHierarchyOption = async () => {
    const result = await ApiLaw.getMaster();
    if (result.status == 200) {
      const { data } = result;
      const hierarchy = Array.isArray(data?.hirachy) ? data.hirachy : [];
      setLawHierarchyOption([
        { value: null, label: "เลือกตามศักดิ์กฎหมาย" },
        ...hierarchy,
      ]);
    }
  };




  useEffect(() => {
    if (pageNo > 1) {
      Swal.showLoading();
      const getSurveyResult = getSurvey({
        search
      });
      try {
        Promise.all([getSurveyResult])
          .then(data => {
            Swal.close();
          })
      } catch (error) {
        Swal.close();
      }
    }
  }, [pageNo]);

  const [agency, setagency] = useState(0);
  const [ministry, setministry] = useState(0);
  const [surveyType, setsurveyType] = useState(null);
  const [lawHierarchy, setLawHierarchy] = useState(null);
  const [statusSurvey, setStatusSurvey] = useState(null);
  const [searchFilter, setSearchFilter] = useState("");
  const [isFilterOpen, setIsFilterOpen] = useState(true);
  const filterDebounceRef = useRef(null);


  const listTextOption = [
    { value: '', label: "ทั้งหมด" },
    { value: "O", label: "เปิดรับฟัง" },
    { value: "I", label: "ปิดรับฟัง" },
  ];

  const cleardata = () => {
    setNonEvaluateSearchDraft("");
    setsearchInputState("");
    setSearchFilter("");
    setStatusSurvey('');
    setagency(0);
    setministry(0);
    setsurveyType('');
    setLawHierarchy(null);
  };

  useEffect(() => {
    if (card_type === "evaluate") {
      return;
    }
    if (filterDebounceRef.current) {
      clearTimeout(filterDebounceRef.current);
    }
    filterDebounceRef.current = setTimeout(() => {
      getFilterSurvey({
        ministry,
        agency,
        surveyType,
        statusSurvey,
        searchFilter,
        lawHierarchy
      });
    }, 200);
    return () => {
      if (filterDebounceRef.current) {
        clearTimeout(filterDebounceRef.current);
      }
    };
  }, [card_type, agency, ministry, surveyType, statusSurvey, searchFilter, lawHierarchy]);


  const [searchInputState, setsearchInputState] = useState('');

  return (
    // <Container maxWidth="xl">
    <div id="listening-v2" className='container-fluid bg-white'>
      <div>
        <section className='section-banner' style={{}}>
          <IndexCarousel history={history} />
        </section>
      </div>


      {
        width >= 768 && (
          <section className='d-flex flex-col'>
            <div className='d-flex container mx-auto'>
              <div className='d-flex flex-1 flex-col h-fit sm:flex hidden mb-5'>
                {
                  card_type != "evaluate" && <div className="search-highlight-wrapper flex-1 max-w-[95%] sm:ml-10">
                    <div className="search-composer" onClick={() => searchInputRef.current?.focus()}>
                      {parseSearchChunks(search.searchText || "").map((chunk, index) => {
                        const isCondition = Boolean(conditionLabelMap[chunk]);
                        const conditionType = conditionValueMap[chunk];
                        return (
                          <span
                            key={`${chunk}-${index}`}
                            className={`search-highlight-token ${isCondition ? `condition-tag condition-tag-${conditionType}` : "term-tag"}`}
                          >
                            {isCondition ? conditionLabelMap[chunk] : chunk}
                            <button
                              type="button"
                              className="search-highlight-x"
                              onMouseDown={(e) => e.preventDefault()}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                removeSearchChunk(index);
                              }}
                            >
                              x
                            </button>
                          </span>
                        );
                      })}
                      <Input
                        ref={searchInputRef}
                        value={nonEvaluateSearchDraft}
                        bordered={false}
                        onKeyDown={(e) => {
                          if (e.key == "Enter") {
                            e.preventDefault();
                            appendSearchTerm(nonEvaluateSearchDraft);
                            setNonEvaluateSearchDraft("");
                          }
                        }}
                        onChange={(e) => {
                          setNonEvaluateSearchDraft(e.target.value)
                        }}
                        className="search-highlight-input"
                        placeholder="พิมพ์คำค้นหาและกด Enter"
                      />
                      <div className="condition-selector" onClick={(e) => e.stopPropagation()}>
                        <span className="condition-label">เงื่อนไข :</span>
                          {conditionText.map((item) => (
                            <button
                              key={item.value}
                              type="button"
                              disabled={!(search.searchText || nonEvaluateSearchDraft.trim())}
                              className={`condition-button condition-button-${item.value} ${(search.searchText || nonEvaluateSearchDraft.trim()) ? "is-available" : "is-inactive"} ${condition_type == item.value ? "active" : ""}`}
                              onClick={() => applyConditionType(item.value)}
                            >
                            {item.label}
                          </button>
                        ))}
                      </div>
                      <button type="button" aria-label='search-law' onClick={(e) => {
                          e.stopPropagation();
                          const composedSearchText = composeSearchTextWithPending(nonEvaluateSearchDraft);
                          if (composedSearchText) {
                            const nextSearch = { ...search, searchText: composedSearchText };
                            setsearch(nextSearch);
                            getSurveySearch(nextSearch);
                            setNonEvaluateSearchDraft("");
                            setisMore(false)
                          } else {
                            getSurveyRefresh();
                            setisMore(true)
                          }

                        }} className='search-button'>
                        <SearchOutlined />
                      </button>
                    </div>
                  </div>
                }

                <div className='flex'>
                  <div className='d-flex items-center gap-x-2 mt-4 sm:ml-10 sm:min-w-[95%]'>
                    <div className='flex flex-col gap-y-2'>
                      <div className="d-flex-align-center gap-y-2 card-type-filter-container" role="tablist" aria-label="เรียงรายการรับฟังความคิดเห็น">
                        {scoreText.map((item) => {
                          return (
                            <button
                              key={item.value}
                              type="button"
                              role="tab"
                              id={`listening-tab-${item.value}`}
                              aria-selected={card_type === item.value}
                              aria-controls="listening-tab-panel"
                              style={{
                                backgroundColor:
                                  card_type == item.value ? item.color : "#fff",
                                borderRadius: 10,
                                boxShadow: 'none',
                                border: '1px solid #cfcfcf'
                              }}
                              className="card-type-filter"
                              onClick={() => setcard_type(item.value)}>
                              <span className="text-regular" style={{ color: card_type == item.value ? "#fff" : item.color, }}>{item.label}</span>
                            </button>
                          )
                        })}
                      </div>
                    </div>

                  </div>
                </div>
                {
                  card_type != "evaluate" && <div className='listening-v2-filters sm:ml-10 !mx-auto flex-1 sm:min-w-[95%] mt-5'>
                    <div className="filter-container">
                      <div>
                        <Card
                          title={
                            <div className="text-filter">
                              <FontAwesomeIcon color={"#6d7481"} icon={faSlidersH} />
                              <label>ตัวกรอง</label>
                            </div>
                          }
                          extra={
                            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                              <div className="clear-filter" onClick={() => cleardata()}>
                                <FontAwesomeIcon color={"#0c4ca3"} icon={faSync} />
                                <label>ล้าง</label>
                              </div>
                              <div
                                style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: 6 }}
                                onClick={() => setIsFilterOpen((prev) => !prev)}
                              >
                                <img
                                  src={StaticImage(!isFilterOpen ? "/images/icon/chevron-circle-down.svg" : "/images/icon/chevron-circle-up.png")}
                                  style={{ marginRight: 5 }}
                                  height={24}
                                  alt="public-no"
                                />
                              </div>
                            </div>
                          }
                          className={`listening-filter-card${!isFilterOpen ? " is-collapsed" : ""}`}
                          style={{ width: "100%", backgroundColor: '#fff', borderRadius: 10 }}
                        // className="Rounded-Rectangle-4-web"
                        >
                          {isFilterOpen && (
                            <div className="filter-grid">
                              <div className="filter-field">
                                <p>สถานะการรับฟัง</p>
                                <Select
                                  className="basic-single"
                                  classNamePrefix="select"
                                  defaultValue={listTextOption[0]}
                                  options={listTextOption}
                                  value={listTextOption.find((x) => x.value == statusSurvey)}
                                  onChange={(item) => {
                                    setStatusSurvey(item.value);
                                  }}
                                />
                              </div>
                              <div className="filter-field">
                                <p> กระทรวง / หน่วยงานอิสระ</p>
                                <Select
                                  className="basic-single"
                                  classNamePrefix="select"
                                  defaultValue={ministryOption[0]}
                                  value={ministryOption.find((x) => x.value == ministry)}
                                  options={ministryOption}
                                  onChange={(item) => {
                                    setministry(item.value);
                                    setagency(0);
                                  }}
                                />
                              </div>
                              <div className="filter-field">
                                <p>กรม</p>
                                <Select
                                  className="basic-single"
                                  classNamePrefix="select"
                                  defaultValue={agencyOption[0]}
                                  options={
                                    ministry > 0
                                      ? agencyOption.filter((x) => x.ministry_id == ministry)
                                      : agencyOption
                                  }
                                  value={agencyOption.find((x) => x.value == agency)}
                                  onChange={(item) => {
                                    setagency(item.value);
                                  }}
                                />
                              </div>
                              <div className="filter-field">
                                <p>ร่างกฎหมาย / ประเมินผลสัมฤทธิ์</p>
                                <Select
                                  className="basic-single"
                                  classNamePrefix="select"
                                  defaultValue={surveyTypeOption[0]}
                                  options={surveyTypeOption}
                                  value={surveyTypeOption.find((x) => x.value == surveyType)}
                                  onChange={(item) => {
                                    setsurveyType(item.value);
                                  }}
                                />
                              </div>
                              <div className="filter-field">
                                <p>ศักดิ์กฎหมาย</p>
                                <Select
                                  className="basic-single"
                                  classNamePrefix="select"
                                  defaultValue={lawHierarchyOption[0]}
                                  options={lawHierarchyOption}
                                  value={lawHierarchyOption.find((x) => x.value == lawHierarchy)}
                                  onChange={(item) => {
                                    setLawHierarchy(item.value);
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        </Card>
                      </div>
                    </div>
                  </div>
                }


                <div
                  id="listening-tab-panel"
                  role="tabpanel"
                  aria-labelledby={`listening-tab-${card_type}`}
                >
                {card_type == "progress" ? <ProjectCardV2
                  agencyOption={agencyOption}
                  ministryOption={ministryOption}
                  surveyTypeOption={surveyTypeOption}
                  getFilterSurvey={getFilterSurvey}
                  handleFavorite={handleFavorite}
                  law_group={law_group}
                  surveys={surveyFilter}
                  entitys={entitys} /> :
                  card_type != "evaluate" ? <SurveyCardV2
                    search={search}
                    setsearch={setsearch}
                    onSearch={(search) => {
                      if (search) {
                        getSurveySearch();
                        setisMore(false)
                      } else {
                        getSurveyRefresh();
                        setisMore(true)
                      }

                    }}
                    agencyOption={agencyOption}
                    ministryOption={ministryOption}
                    surveyTypeOption={surveyTypeOption}
                    getFilterSurvey={getFilterSurvey}
                    handleFavorite={handleFavorite}
                    law_group={law_group}
                    surveys={surveyFilter}
                    entitys={entitys} /> :
                    <EvaluationDeadlineView />}
                </div>

                {

                  card_type != "evaluate" && pageNo !== totalPage && isMore && <div className='flex justify-center mb-4'>
                    <button className='button-theme button-theme-blue-45 ' onClick={() => {
                      setPageNo(pageNo + 1)
                    }}>ดูเพิ่มเติม</button>
                  </div>
                }
              </div>
            </div>

          </section>
        )
      }
      {
        width < 768 && (
          <section>
            {card_type != "evaluate" && (
              <div className="search-highlight-wrapper search-highlight-wrapper-mobile px-3 mb-4">
                <div className="search-composer" onClick={() => searchInputRef.current?.focus()}>
                  {parseSearchChunks(search.searchText || "").map((chunk, index) => {
                    const isCondition = Boolean(conditionLabelMap[chunk]);
                    const conditionType = conditionValueMap[chunk];
                    return (
                      <span
                        key={`${chunk}-${index}`}
                        className={`search-highlight-token ${isCondition ? `condition-tag condition-tag-${conditionType}` : "term-tag"}`}
                      >
                        {isCondition ? conditionLabelMap[chunk] : chunk}
                        <button
                          type="button"
                          aria-label={`ลบ ${isCondition ? conditionLabelMap[chunk] : chunk}`}
                          className="search-highlight-x"
                          onMouseDown={(e) => e.preventDefault()}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            removeSearchChunk(index);
                          }}
                        >
                          x
                        </button>
                      </span>
                    );
                  })}
                  <Input
                    ref={searchInputRef}
                    value={nonEvaluateSearchDraft}
                    bordered={false}
                    enterKeyHint="done"
                    onKeyDown={(e) => {
                      if (e.key == "Enter") {
                        e.preventDefault();
                        appendSearchTerm(nonEvaluateSearchDraft);
                        setNonEvaluateSearchDraft("");
                      }
                    }}
                    onChange={(e) => setNonEvaluateSearchDraft(e.target.value)}
                    className="search-highlight-input"
                    placeholder="พิมพ์คำค้นหาและกด Enter"
                  />
                  <button
                    type="button"
                    aria-label="ค้นหาโครงการรับฟัง"
                    className="search-button"
                    onClick={(e) => {
                      e.stopPropagation();
                      const composedSearchText = composeSearchTextWithPending(nonEvaluateSearchDraft);
                      if (composedSearchText) {
                        const nextSearch = { ...search, searchText: composedSearchText };
                        setsearch(nextSearch);
                        getSurveySearch(nextSearch);
                        setNonEvaluateSearchDraft("");
                        setisMore(false);
                      } else {
                        getSurveyRefresh();
                        setisMore(true);
                      }
                    }}
                  >
                    <SearchOutlined />
                  </button>
                  <div className="condition-selector" onClick={(e) => e.stopPropagation()}>
                    <span className="condition-label">เงื่อนไข :</span>
                    {conditionText.map((item) => (
                      <button
                        key={item.value}
                        type="button"
                        disabled={!(search.searchText || nonEvaluateSearchDraft.trim())}
                        className={`condition-button condition-button-${item.value} ${(search.searchText || nonEvaluateSearchDraft.trim()) ? "is-available" : "is-inactive"} ${condition_type == item.value ? "active" : ""}`}
                        onClick={() => applyConditionType(item.value)}
                      >
                        {item.label}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            )}
            <div className="card-type-filter-container d-flex px-3 mb-3" role="tablist" aria-label="เรียงรายการรับฟังความคิดเห็น">
              {scoreText.map((item) => (
                <button
                  key={item.value}
                  type="button"
                  role="tab"
                  id={`listening-mobile-tab-${item.value}`}
                  aria-selected={card_type === item.value}
                  aria-controls="listening-mobile-tab-panel"
                  className="card-type-filter"
                  style={{
                    backgroundColor: card_type === item.value ? item.color : "#fff",
                    border: "1px solid #cfcfcf",
                    borderRadius: 10,
                    boxShadow: "none",
                  }}
                  onClick={() => setcard_type(item.value)}
                >
                  <span className="text-regular" style={{ color: card_type === item.value ? "#fff" : item.color }}>
                    {item.label}
                  </span>
                </button>
              ))}
            </div>
            <div
              id="listening-mobile-tab-panel"
              role="tabpanel"
              aria-labelledby={`listening-mobile-tab-${card_type}`}
            >
            {card_type == "progress" ? <ProjectCardV2Mobile
              agencyOption={agencyOption}
              ministryOption={ministryOption}
              surveyTypeOption={surveyTypeOption}
              getFilterSurvey={getFilterSurvey}
              handleFavorite={handleFavorite}
              law_group={law_group}
              surveys={surveyFilter}
              entitys={entitys} /> :
              card_type != "evaluate" ?
                <SurveyCardV2Mobile
                  agencyOption={agencyOption}
                  ministryOption={ministryOption}
                  surveyTypeOption={surveyTypeOption}
                  getFilterSurvey={getFilterSurvey}
                  handleFavorite={handleFavorite}
                  law_group={law_group}
                  surveys={surveyFilter}
                  entitys={entitys} /> :
                <EvaluationDeadlineView />
            }
            </div>
            {
              card_type != "evaluate" && pageNo !== totalPage && isMore && <div className='flex justify-center mb-4'>
                <button className='button-theme button-theme-blue-45 ' onClick={() => {
                  setPageNo(pageNo + 1)
                }}>ดูเพิ่มเติม</button>
              </div>
            }
          </section>
        )
      }
    </div >
  );
};

export default ListeningPageindex;
